<div class="reward-header-lc">
  <span class="reward-header-name">{{ name }}</span>
  <span class="reward-header-description">{{ description }}</span>
</div>
<div class="reward-header-rc">
  <ng-content></ng-content>
</div>
